/* add_device.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 20 16" preserveAspectRatio="none">
            <g>
                <g>
                    <g>
                        <g>
                            <path class="foreground-gl" d="M12,0c-2.1,0-4,0.8-5.4,2.1c0.4,0.1,0.8,0.4,1.1,0.7C8.2,3.4,8.4,4.1,8.3,5l0,0.1c0.4,0,1.3,0.1,2,0.9
                                c0.5,0.6,0.6,1.3,0.5,2.2l0,0.2c-0.2,1.5-1.3,2.4-2.8,2.4H7.4l-0.1,0.9c-0.1,0.8-0.5,1.4-1,1.8C7.7,15,9.7,16,12,16
                                c4.4,0,8-3.6,8-8C20,3.6,16.4,0,12,0z"/>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <path class="foreground-gl" d="M13.4,8l2.9-1.2l-0.4,0.9h2.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4h-2.4l0.4,0.9L13.4,8z"/>
                        </g>
                    </g>
                    <g>
                        <g>
                            <path class="foreground-gl" d="M12,1.3l-1.2,3l0.9-0.4v2.4c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V3.9l0.9,0.4L12,1.3z"/>
                        </g>
                        <g>
                            <path class="foreground-gl" d="M12,14.7l-1.2-3l0.9,0.4V9.7c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.4l0.9-0.4L12,14.7z"/>
                        </g>
                    </g>
                </g>
                <path class="foreground-gl" d="M7.8,7.8l0,0.3C7.7,8.6,7.5,8.7,6.9,8.7H4.7l-0.4,2.6C4.2,11.8,4,12,3.4,12H3.1c-0.5,0-0.7-0.2-0.6-0.7
                    l0.4-2.6H0.7C0.1,8.7-0.1,8.6,0,8.1l0-0.3c0.1-0.5,0.3-0.7,0.9-0.7h2.2l0.4-2.4C3.6,4.1,3.9,4,4.4,4h0.3c0.5,0,0.7,0.1,0.6,0.7
                    L4.9,7.1h2.2C7.8,7.1,7.9,7.2,7.8,7.8z"/>
            </g>
            </svg>
         `
};
